import { useLocation } from 'react-router-dom';

export const getKeysOfObject = <T extends {}>(obj: T) => (
    (Object.keys(obj) as unknown as Array<keyof T>)
);

export const NumberOf = (value: unknown) => {
    let numberValue = Number(value);
    if (Number.isNaN(numberValue)) {
        numberValue = 0;
    }
    return numberValue;
};

export const useUrlQuery = () => (
    new URLSearchParams(useLocation().search)
);

export const performOnNextStack = (action: Function) => {
    Promise.resolve(true).then(() => action());
};

export const isOfType = <T extends object>(
    obj: unknown,
    mustHaveProperties: Array<keyof T>,
): obj is T => {
    for (let index = 0; index < mustHaveProperties.length; index += 1) {
        const aMustHaveProperty = mustHaveProperties[index];
        if ((obj as T)[aMustHaveProperty] === undefined) {
            return false;
        }
    }
    return true;
};

export const downloadFile = (file: Blob, filename: string) => {
    const downloadUrl = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = downloadUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
};

export const copyTextToClipboard = async (text: string) => {
    try {
        await navigator.clipboard.writeText(text);
    } catch (error) {
        console.error(error);
    }
};
